import React from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import CustomerDetails from '../pages/CustomerDetails';
import Search from '../pages/Search';
import Tip from '../pages/Tip';
import Payment from '../pages/Payment';
import PaymentProcessing from '../pages/PaymentProcessing';

const DebugRouter: React.FC<any> = ({ children }) => {
    const location = useLocation();
    if (process.env.NODE_ENV === 'development') {
        console.debug(`Route: ${location.pathname}${location.search}`);
    }

    return children;
};

const AppRoutes: React.FC = () => {
    return (
        <BrowserRouter>
            <DebugRouter>
                <Routes>
                    <Route element={<Search />} path="/" />
                    <Route element={<CustomerDetails />} path="/payment/customerDetails" />
                    <Route element={<Payment />} path="/payment" />
                    <Route element={<PaymentProcessing />} path="/payment/processing" />
                    <Route element={<Tip />} path="/:memberId" />
                </Routes>
            </DebugRouter>
        </BrowserRouter>
    );
};

export default AppRoutes;
